import { ref, watch } from 'vue';
import type { BankCBRF } from '@/modules/common/adapters/bank-cbrf.type.ts';
import type { SourcedOption } from '@/modules/common/types/option.type.ts';
import {
  BANK_BIK_MAX_LENGTH,
  BANK_CORRESPONDENT_ACCOUNT_MAX_LENGTH,
  BANK_SETTLEMENT_ACCOUNT_MAX_LENGTH,
} from '@/modules/common/consts/max-length.ts';

export const BANK_DETAILS_DIGITS_MASK = {
  bik: '#'.repeat(BANK_BIK_MAX_LENGTH),
  correspondentAccount: '#'.repeat(BANK_CORRESPONDENT_ACCOUNT_MAX_LENGTH),
  settlementAccount: '#'.repeat(BANK_SETTLEMENT_ACCOUNT_MAX_LENGTH),
} as const;

export type MasterBankDetailsFormModel = {
  bank: SourcedOption<BankCBRF> | null;
  bankIdentificationCode: string;
  correspondentAccount: string;
  currentAccount: string;
  comment: string;
};

export function useMasterBankDetailsForm() {
  const INITIAL_FORM_DATA: MasterBankDetailsFormModel = {
    bank: null,
    bankIdentificationCode: '',
    correspondentAccount: '',
    currentAccount: '',
    comment: '',
  };

  const formData = ref<MasterBankDetailsFormModel>({ ...INITIAL_FORM_DATA });

  watch(
    () => formData.value.bank,
    (next) => {
      formData.value.bankIdentificationCode = next?.source?.identificationCode ?? '';
      formData.value.correspondentAccount = next?.source?.correspondentAccount ?? '';
    }
  );

  return {
    INITIAL_FORM_DATA,
    formData,
  };
}
